<template>
    <!--visitSource = 2 pc端 -->
    <div v-if="visitSource == 2">
      <examinationHeader v-if="ifHead" ref="header" :initActiveName="pageInfo.initActiveName+''"></examinationHeader>
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="ifHead?18:24" :lg="ifHead?18:24" :xl="ifHead?18:24">
          <kw_list ref="kw_list" id="kw_list" v-if="(pageInfo.ifLoaded)" :initPageObj="pageInfo" :mainId="mainId" @goBack="goBack" :isLimitButton="isLimitButton"></kw_list>
        </el-col>
      </el-row>
      <examinationFooter v-if="ifHead"></examinationFooter>
    </div> 

    <!--visitSource = 3  移动端 -->
    <div v-else :class="(ifHead?'new_list':'')">
      <div class="title_container" v-if="ifHead">
        <i class="el-icon-arrow-left" @click="goBack" style="font-weight: bold"></i>
        <!-- <img src="../../../components/list/img/logo.png" alt="logo" class="logo_img"> -->
        <span class="system_title">{{loginTitle}}</span>
      </div>
      <kw_list ref="kw_list" id="kw_list" v-if="(pageInfo.ifLoaded)" :initPageObj="pageInfo" :mainId="mainId" @goBack="goBack" :isLimitButton="isLimitButton"></kw_list>
    </div>
    <!-- 分享图片 画布生成功能 -->
    <!-- <kw_image_canvas wx:if="{{imageCanvasInfo.ifLoad}}"></kw_image_canvas> -->
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
//PC考试底部内容
import examinationFooter from '@/components/footer/examinationFooter.vue';
//PC考试头部内容
import examinationHeader from '@/components/header/examinationHeader.vue';
export default {
  name: 'new_list',
  props: {
    
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      pageInfo: {
        ifLoaded:false
        // tableId: 448,
        // pageId: 22592,
        // pageType:11,
        // listTableId: 448,
        // mainId: 139176,
        // callBackType
        // initCheckId
        // dataMaxNum
        // sourceListMainId
        // jumpWay
        // initSearchVal
      },
      mainId:0,
      // 分享图片 画布生成功能
      imageCanvasInfo:{
        ifLoad:false
      },
      ifHead:true,
      //打开方式
      openWay:null,
      //按钮是否根据角色权限限制
      isLimitButton: false,
      loginTitle:"可为低代码平台"
    };
  },
  created() {
    var that = this;
    // 判断移动端是否是flutter内打开
    if(this.visitSource == 3) {
      try {
        var ifHead = _flutterToOpenLookPage?false:true;
        this.ifHead = ifHead;
      } catch (error) {
      }
    }
    if(localStorage.domain_name && localStorage.domain_name != "") {
      that.loginTitle = that.GLOBAL.loginProductName[localStorage.domain_name];
    } else {
      that.loginTitle = that.GLOBAL.defaultProductName;;
    }
    //请求地址传递的参数
    var options = this.$route.params;
    if(!options.pageId) {
      options = this.$route.query;
    }
    var kw_param = options.kw_param;
    kw_param = utils.kwAtob(kw_param);
    var kwParamArr = kw_param.split("_");
    var listParam = that.GLOBAL.listParam;
    listParam.forEach((key,keyIndex) => {
      if(kwParamArr.length>keyIndex && kwParamArr[keyIndex] != "") {
        options[key] = kwParamArr[keyIndex];
      }
    });
    // options = JSON.parse(kw_param);
    var pageInfo = {};
    if (options) {
      pageInfo = options;
    }
    // 默认需要选中的搜索条件
    // pageInfo.initSearchVal = options.initSearchVal;
    var mainId = 0;
    if (options.mainId) {
      mainId = options.mainId;
    }
    if(options.noHead==1) {
      that.ifHead = false;
    }
    if(options.openWay==2) {
      that.openWay = 2;
    }
    if(options.isLimitButton || options.isLimitButton == "true") {
      that.isLimitButton = true;
    }
    // if(pageInfo.menuName) {
    //   that.loginTitle = pageInfo.menuName;
    // }
    // 如果是扫码进入 获取扫码的参数信息 并进行处理 传递到后台
    pageUtils.initScene(this, options.scene, pageInfo);
    console.log("options===========111===========", options);
    pageInfo.ifLoaded = true;
    that.pageInfo=pageInfo;
    that.mainId=mainId;
    pageUtils.flutterWebPageFinished();
  },
  mounted() {
    var that = this;
    window.zdyRefreshPage = (e) => {
      that.zdyRefreshPage();
    }
  },
  watch:{
  },
  computed:{
  },
  components: {
    examinationFooter,
    examinationHeader,
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      vm.fromPath = from.path;
        console.log(to)
      console.log(from)
    });
  },
  methods: {
    //    后退
    goBack(){
      var that = this;
      // 判断查看或者列表页面是否设置为返回首页
      console.log("that.$router=====================================",that.fromPath);
      console.log("window.history.length============================",window.history);
      var prevIfHome = 0;
      if(that.$refs.kw_list && that.$refs.kw_list.pageSetInfo && that.$refs.kw_list.pageSetInfo.listStyleSet) {
        prevIfHome =  that.$refs.kw_list.pageSetInfo.listStyleSet.prevIfHome;
      } 
      if(that.fromPath && that.fromPath.indexOf("/mailHome") == 0) {
        prevIfHome = 1;
      }
      var ifWxMiniProgram = false;
      wx.miniProgram.getEnv(function(res) {
          console.log("res.miniprogram==========================",res) // true
          if(res.miniprogram) {
              if(prevIfHome == 1) {
                //跳转首页
                wx.miniProgram.reLaunch({
                  url: '/pages/home/mailHome'
                })
              } else {
                //关闭当前页并返回上一页
                wx.miniProgram.navigateBack({})
              }
              ifWxMiniProgram = true;
          }
      })
      if(!ifWxMiniProgram) {
        var ifFlutter = false;
        try {
          _flutterClosePage.postMessage(prevIfHome);
          ifFlutter = true;
        } catch (error) {
          ifFlutter = false;
        }
        if(!ifFlutter) {
          console.log("prevIfHome==========================",prevIfHome,that.$router);
          if(prevIfHome == 1 || window.history.length <= 2) {
            pageUtils.toMailHome(that);
          } else {
            that.$router.back();
          }
        }
      }
    },
    
    /**
     * 刷新页面的操作
     */
    zdyRefreshPage: function () {
      var that = this;
      var pageInfo = this.pageInfo;
      pageInfo.ifLoaded = false;
      that.pageInfo = pageInfo;
      that.$nextTick(function(){
        pageInfo.ifLoaded = true;
        that.pageInfo = pageInfo;
      });
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .new_list{padding-top: 37px}
  .title_container{padding: 5px;position: fixed;left: 0;top: 0;background: #ffffff;width: 100%;z-index: 999}
  .logo_img{width: 25px;height: 25px;margin-left: 40px}
  .system_title{font-size: 18px;color: #000;vertical-align:middle}
  .el-icon-arrow-left{font-size: 20px;vertical-align: middle;font-weight: bold !important;}
  .el-footer{padding: 0}
</style>
